// extracted by mini-css-extract-plugin
export default {"card":"card_card__YBCL6","left":"card_left__Md-iv","title":"card_title__h0ko0","description":"card_description__wtE-v","right":"card_right__aWrCe","card-img":"card_card-img__YiPNO"};